<template>
  <div class="home-detail-page">
    <div class="breadcrumb">
      <img :src="pointImg" alt="" class="breadcrumb-icon">
      <span>当前位置：
        <span class="breadcrumb-link" @click="$emit('go-home')">首页</span>
        <span v-if="!hideSidebar"> / <span class="breadcrumb-link" @click="$emit('go-list', currentSection)">{{ currentSection }}</span></span>
        <span> / {{ article.title }}</span>
      </span>
    </div>
    <div class="detail-layout">
      <div class="detail-sidebar" v-if="!hideSidebar">
        <div class="sidebar-title">资讯列表</div>
        <div class="side-menu">
          <div v-for="(item, index) in sideMenu" :key="index"
            class="side-item" :class="{ active: activeSide === index }"
            @click="$emit('go-list', sideMenu[index])">{{ item }}</div>
        </div>
      </div>
      <div class="detail-content">
        <div class="detail-title">{{ article.title }}</div>
        <div class="detail-date">{{ article.date }}</div>
        <div class="detail-body">
          <div v-if="article.content" v-html="article.content"></div>
          <p v-else>{{ article.desc || article.title }}</p>
        </div>
        <div v-if="nextTitle" class="next-article" @click="goNext">
          下一篇：{{ nextTitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pointImg from '../assets/imgs/point.png'

export default {
  name: 'HomeDetail',
  props: {
    article: { type: Object, required: true },
    section: { type: String, default: '景区动态' },
    hideSidebar: { type: Boolean, default: false },
    listNews: { type: Array, default: () => [] },
    listCulture: { type: Array, default: () => [] },
    listGuide: { type: Array, default: () => [] },
    listGov: { type: Array, default: () => [] },
    listConsult: { type: Array, default: () => [] },
    listScene: { type: Array, default: () => [] },
  },
  emits: ['go-home', 'go-list', 'next-article'],
  data() {
    const sideMap = { '景区动态': 0, '景区文化': 1, '旅游攻略': 2, '政务公开': 3, '政务信息': 4, '景区风光': 5 }
    return {
      pointImg,
      sideMenu: ['景区动态', '景区文化', '旅游攻略', '政务公开', '政务信息', '景区风光'],
      currentSection: this.section,
      currentArticle: this.article,
      currentIndex: -1,
    }
  },
  computed: {
    activeSide() {
      const map = { '景区动态': 0, '景区文化': 1, '旅游攻略': 2, '政务公开': 3, '政务信息': 4, '景区风光': 5 }
      return map[this.currentSection] !== undefined ? map[this.currentSection] : 0
    },
    currentData() {
      const map = [this.listNews, this.listCulture, this.listGuide, this.listGov, this.listConsult, this.listScene]
      return map[this.activeSide] || []
    },
    nextTitle() {
      if (this.currentIndex >= 0 && this.currentIndex < this.currentData.length - 1) {
        return this.currentData[this.currentIndex + 1].title
      }
      return ''
    },
  },
  mounted() {
    this.currentIndex = this.currentData.indexOf(this.article)
  },
  methods: {
    goNext() {
      if (this.currentIndex < this.currentData.length - 1) {
        this.currentIndex++
        this.currentArticle = this.currentData[this.currentIndex]
        this.$emit('next-article', this.currentArticle)
      }
    },
  },
}
</script>

<style scoped lang="less">
.home-detail-page{
  padding-bottom: 0.4rem;
  .breadcrumb{
    padding-top: 0.2rem;
    padding-left: 0.1rem;
    padding-bottom: 0.2rem;
    font-size: 0.24rem;
    color: #666;
    display: flex;
    align-items: center;
    .breadcrumb-icon{
      width: 0.2rem;
      margin-right: 0.1rem;
    }
    .breadcrumb-link{
      cursor: pointer;
      &:hover{ color: #369BF8; }
    }
  }
  .detail-layout{
    display: flex;
    margin-top: 0.3rem;
    gap: 0.2rem;
    .detail-sidebar{
      width: 3.23rem;
      flex-shrink: 0;
      .sidebar-title{
        height: 0.7rem;
        line-height: 0.7rem;
        text-align: center;
        font-size: 0.29rem;
        color: #fff;
        background: #369BF8;
      }
      .side-menu{
        border: 1px solid #e0e0e0;
        border-top: none;
        padding: 0.2rem 0;
        .side-item{
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.24rem;
          color: #787A7B;
          cursor: pointer;
          position: relative;
          &::after{
            content: '';
            position: absolute;
            left: 0.15rem;
            right: 0.15rem;
            bottom: 0;
            height: 1px;
            background: #e0e0e0;
          }
          &:last-child::after{ display: none; }
          &.active{
            font-size: 0.27rem;
            color: #1372C9;
            gap: 0.08rem;
            &::before{
              content: '';
              width: 0;
              height: 0;
              border-top: 0.06rem solid transparent;
              border-bottom: 0.06rem solid transparent;
              border-left: 0.09rem solid #369BF8;
              flex-shrink: 0;
            }
          }
        }
      }
    }
    .detail-content{
      flex: 1;
      min-width: 0;
      min-height: 10rem;
      padding: 0 0.25rem;
      .detail-title{
        font-size: 0.32rem;
        font-weight: bold;
        color: #000;
        text-align: center;
        margin-bottom: 0.15rem;
      }
      .detail-date{
        font-size: 0.18rem;
        color: #999;
        text-align: center;
        margin-bottom: 0.3rem;
      }
      .detail-body{
        p{
          font-size: 0.2rem;
          color: #4F4E4E;
          line-height: 2;
          text-indent: 2em;
          margin-bottom: 0.15rem;
        }
      }
      .next-article{
        margin-top: 0.4rem;
        font-size: 0.2rem;
        color: #369BF8;
        cursor: pointer;
        text-align: left;
        &:hover{ color: #1a6bb5; }
      }
    }
  }
}
</style>
